export default "__VITE_ASSET__6ae9ff37__"